import Vue from "vue";
import vailcode from "@utils/errcode";
import cookie from "js-cookie";
import querystring from "querystring";

export default {
  namespaced: true,
  state: {
    luckyList: [],
    luckyItems: [],
    luckyLogs: [],
    luckyLogHasMore: false,
    luckyLogLoading: false,
    luckyLogCondition: {
      lotteryId: "",
      page: 1,
      limit: 20,
    },
  },
  mutations: {
    setLuckyList: (state, payload) => {
      state.luckyList = payload;
    },
    setLuckyItems: (state, payload) => {
      state.luckyItems = payload;
    },
    setLuckyLogs: (state, payload) => {
      state.luckyLogs = payload;
    },
    setLuckyLogCondition: (state, payload) => {
      state.luckyLogCondition = payload;
    },
    setLuckyLogLoading: (state, payload) => {
      state.luckyLogLoading = payload;
    },
    setLuckyLogHasMore: (state, payload) => {
      state.luckyLogHasMore = payload;
    },
    appendLuckyLog: (state, payload) => {
      state.luckyLogs = state.luckyLogs.concat(payload);
    },
  },
  actions: {
    getLuckyList: async ({ state, commit }, [provider, type]) => {
      const rs = await Vue.prototype.$http.post("/lucky/lottery/list", { provider, type });
      vailcode(rs, () => {
        commit("setLuckyList", rs.data);
      });
    },
    getLuckyItems: async ({ state, commit }, lotteryId) => {
      const rs = await Vue.prototype.$http.post("/lucky/lottery/items", { lotteryId });
      vailcode(rs, () => {
        commit("setLuckyItems", rs.data);
      });
    },
    getLuckyLogs: async ({ state, commit }, [callback, failcallback]) => {
      if (state.luckyLogLoading) return;
      commit("setLuckyLogLoading", true);
      const rs = await Vue.prototype.$http.post("/lucky/lottery/logs", state.luckyLogCondition);
      vailcode(
        rs,
        () => {
          if (rs.data.currentPage == 1) {
            commit("setLuckyLogs", rs.data.items);
          } else {
            commit("appendLuckyLog", rs.data.items);
          }
          if (rs.data.lastPage > rs.data.currentPage) {
            commit("setLuckyLogHasMore", true);
          } else {
            commit("setLuckyLogHasMore", false);
          }
          commit("setLuckyLogLoading", false);
          typeof callback == "function" && callback(rs.data);
        },
        () => {
          typeof failcallback == "function" && failcallback(rs);
        }
      );
    },
    luckyDraw: async ({ state, commit }, [lotteryId, callback, failcallback, priceType, count]) => {
      let params = { lotteryId, requestId: new Date().getTime() };
      if (priceType) {
        params["priceType"] = priceType;
      }
      if (count) {
        params["count"] = count;
      }
      const rs = await Vue.prototype.$http.post("/lucky/lottery/draw", params);
      //   const rs = {
      //     "code": 0,
      //     "message": "",
      //     "data": {
      //         "lottery": {
      //             "id": 1,
      //             "provider": "official",
      //             "title": "Crypto Spin",
      //             "icon": "https://static.tapcoins.xyz/20240813/f7275f30-b77e-456d-98f4-bae5cf71c5d0.png",
      //             "type": 0,
      //             "price_type": "tap",
      //             "price_coin": 0,
      //             "price_stock": 0,
      //             "price_tap": 200,
      //             "count": 1
      //         },
      //         "winning_item": {
      //             "id": 19,
      //             "title": "x8",
      //             "icon": "",
      //             "disp_combo": [
      //                 "TAPGIFTSHARD",
      //                 "TAPGIFTSHARD",
      //                 "TAPGIFTSHARD"
      //             ],
      //             "currency": "TAPGIFTSHARD",
      //             "gift_extra": null,
      //             "amount": {
      //                 "12": {
      //                     "type": 1,
      //                     "name": "Durov’s Caps",
      //                     "thumb": "https://static.tapcoins.app/202508/01/4986cee5-7c77-4e61-94df-f431af68b054.png",
      //                     "image": "https://static.tapcoins.app/202508/01/d0fb7a9a-771a-4119-8636-b5e3ce46403f.png",
      //                     "amount": 1
      //                 },
      //                 "13": {
      //                     "type": 1,
      //                     "name": "Precious Peaches ",
      //                     "thumb": "https://static.tapcoins.app/202508/01/74f8e133-9bf2-4695-bcad-294e62619a1b.png",
      //                     "image": "https://static.tapcoins.app/202508/01/e2573bf3-08aa-43e3-ac1a-c70b9bdf7609.png",
      //                     "amount": 1
      //                 },
      //                 "16": {
      //                     "type": 1,
      //                     "name": "Gem Signets ",
      //                     "thumb": "https://static.tapcoins.app/202508/01/8195c445-078e-400e-9a64-2f11e225b9cd.png",
      //                     "image": "https://static.tapcoins.app/202508/01/1db65630-1d8f-4618-acd5-b950067e942a.png",
      //                     "amount": 1
      //                 },
      //                 "17": {
      //                     "type": 1,
      //                     "name": "Loot Bags ",
      //                     "thumb": "https://static.tapcoins.app/202508/01/c1b34d39-3d2b-4d79-8d54-6f81f767d45f.png",
      //                     "image": "https://static.tapcoins.app/202508/01/61df5f12-894d-4ee9-9d21-86e53f82c314.png",
      //                     "amount": 1
      //                 },
      //                 "18": {
      //                     "type": 1,
      //                     "name": "Perfume Bottles",
      //                     "thumb": "https://static.tapcoins.app/202508/01/3b1865d9-7665-41d0-a07a-624bc9250029.png",
      //                     "image": "https://static.tapcoins.app/202508/01/a7e1685d-b6b2-47c1-b298-c412cf3cf035.png",
      //                     "amount": 1
      //                 },
      //                 "22": {
      //                     "type": 1,
      //                     "name": "Astral Shards",
      //                     "thumb": "https://static.tapcoins.app/202508/04/3bcfe536-b4c1-4b6a-8ec0-01c8c0651795.png",
      //                     "image": "https://static.tapcoins.app/202508/04/dd01e855-b852-4f3b-9842-f914beb9ac6a.png",
      //                     "amount": 3
      //                 }
      //             },
      //             "unit_amount": 8,
      //             "count": 1,
      //             "log_id": 2475,
      //             "user_gift_id": null,
      //             "lround": -1
      //         },
      //         "user": {
      //             "id": 4129783,
      //             "tg_id": "6605438145",
      //             "username": "wjm12345",
      //             "firstname": "wjm123",
      //             "lastname": "",
      //             "head_color": "#674849",
      //             "avatar_url": null,
      //             "total_reward": 0,
      //             "extra_invite_count": 0,
      //             "bind_wallet": "UQBaHGAc0mGxlAbnqvFQ1HBqVo5_8haeNaKcCUoJoPjIX0kb",
      //             "coin": 999942789,
      //             "diamond": 0,
      //             "fragment": 236,
      //             "stock": 78044,
      //             "total_stock": 78038,
      //             "ref_code": "ZpSsFD",
      //             "user_level": 1,
      //             "user_group_id": null,
      //             "power_max": 1000,
      //             "power": 1000,
      //             "multi_tap": 1,
      //             "turbo_temp_times": 0,
      //             "turbo_temp": 0,
      //             "turbo_count": 3,
      //             "turbo_max": 3,
      //             "refill_count": 3,
      //             "refill_max": 3,
      //             "multi_tap_level": 0,
      //             "power_level": 0,
      //             "recharge_speed": 1,
      //             "recharge_speed_level": 0,
      //             "auto_bot": 0,
      //             "bot_level": 0,
      //             "skin": "basic",
      //             "joined_twitter": 1,
      //             "joined_telegram": 0,
      //             "joined_channel": 0,
      //             "joined_discord": 0,
      //             "ton_wallet": null,
      //             "ton_gas_paid": 0,
      //             "verified_premium": 0,
      //             "verified_face": 0,
      //             "verified_mpay": 0,
      //             "verified_boost_channel": 0,
      //             "verified_with_tapcoins": 0,
      //             "app_center_tickets": 0
      //         }
      //     }
      // }
      vailcode(
        rs,
        () => {
          typeof callback == "function" && callback(rs.data);
        },
        () => {
          typeof failcallback == "function" && failcallback(rs);
        }
      );
    },
  },
  getters: {},
};
